<template>
    <div>
        <div v-html="html"></div>
    </div>
</template>
<script>
    export default {
        props:['html']
    }
</script>